import { render } from "./CustomerChat.vue?vue&type=template&id=3c16098f&scoped=true"
import script from "./CustomerChat.vue?vue&type=script&lang=js"
export * from "./CustomerChat.vue?vue&type=script&lang=js"

import "./CustomerChat.vue?vue&type=style&index=0&id=3c16098f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c16098f"]])

export default __exports__